/* =====================================================================
   21 MARS — Quick-add carte collection (MOBILE)
   - injecte un bouton "+" sur chaque carte "Style 1"
   - au tap : bottom sheet "Choisis ta taille" (tailles du produit)
   - ajout via l'API standard Shopify (/cart/add.js) -> robuste, indép. du thème
   - lien "Besoin d'aide pour ta taille ?" -> calculateur
   Ne s'active que sous 1000px (desktop = comportement du thème inchangé).
   ===================================================================== */
(function () {
  'use strict';

  var TAILLE_URL = '/pages/guide-des-tailles-1'; // calculateur
  function isMobile() { return window.innerWidth < 1000; }

  // --- handle produit depuis la carte ---
  function handleFromCard(card) {
    var a = card.querySelector('.product-card__name')
         || card.querySelector('a.product-card__image')
         || card.querySelector('a[href*="/products/"]');
    if (!a) return null;
    var m = (a.getAttribute('href') || '').match(/\/products\/([^/?#]+)/);
    return m ? m[1] : null;
  }

  // --- bottom sheet (singleton) ---
  var dim, sheet;
  function ensureSheet() {
    if (sheet) return;
    dim = document.createElement('div'); dim.className = 'cc-dim';
    sheet = document.createElement('div'); sheet.className = 'cc-sheet'; sheet.setAttribute('role', 'dialog');
    document.body.appendChild(dim); document.body.appendChild(sheet);
    dim.addEventListener('click', closeSheet);

    // Fermer en tapant la poignée
    sheet.addEventListener('click', function (e) {
      if (e.target.classList && e.target.classList.contains('cc-handle')) closeSheet();
    });

    // Fermer en glissant vers le bas (uniquement quand on est en haut du contenu)
    var startY = 0, curY = 0, dragging = false;
    sheet.addEventListener('touchstart', function (e) {
      startY = e.touches[0].clientY; curY = startY; dragging = true;
      sheet.style.transition = 'none';
    }, { passive: true });
    sheet.addEventListener('touchmove', function (e) {
      if (!dragging) return;
      curY = e.touches[0].clientY;
      var dy = curY - startY;
      if (dy > 0 && sheet.scrollTop <= 0) sheet.style.transform = 'translateY(' + dy + 'px)';
    }, { passive: true });
    sheet.addEventListener('touchend', function () {
      if (!dragging) return; dragging = false;
      sheet.style.transition = '';
      if (curY - startY > 90) { closeSheet(); }
      else { sheet.style.transform = ''; }
    });
  }
  function openSheet(html) {
    ensureSheet();
    sheet.innerHTML = html;
    dim.classList.add('cc-open');
    requestAnimationFrame(function () { sheet.classList.add('cc-open'); });
    document.body.style.overflow = 'hidden';
  }
  function closeSheet() {
    if (!sheet) return;
    sheet.style.transition = '';
    sheet.style.transform = '';
    sheet.classList.remove('cc-open');
    dim.classList.remove('cc-open');
    document.body.style.overflow = '';
  }

  // --- index de l'option "Taille" ---
  function sizeOptionIndex(product) {
    var opts = product.options || [];
    for (var i = 0; i < opts.length; i++) {
      var name = (typeof opts[i] === 'string') ? opts[i] : (opts[i].name || '');
      if (/taille|size/i.test(name)) return i;
    }
    return 0; // sinon la 1re option
  }

  function detectType(p) {
    var t = ((p.type || '') + ' ' + ((p.tags || []).join(' ')) + ' ' + (p.title || '')).toLowerCase();
    if (/culotte|shorty|\bbas\b/.test(t)) return 'bas';
    return 'haut';
  }

  function sheetHTML(product, cardTitle, cardPriceHTML, type) {
    var idx = sizeOptionIndex(product);
    var seen = {}, rows = '';
    (product.variants || []).forEach(function (v) {
      var val = (v.options || [])[idx];
      if (val == null || seen[val]) return;
      seen[val] = 1;
      var off = v.available ? '' : ' cc-off';
      rows += '<button type="button" class="cc-sz' + off + '" data-vid="' + v.id + '"'
            + (v.available ? '' : ' disabled') + '>' + val + '</button>';
    });
    return '<div class="cc-handle"></div>'
      + '<div class="cc-top"><div class="cc-nom">' + (cardTitle || product.title) + '</div>'
      + '<div class="cc-prix">' + (cardPriceHTML || '') + '</div></div>'
      + '<div class="cc-lbl">Choisis ta taille</div>'
      + '<div class="cc-sizes">' + rows + '</div>'
      + '<button type="button" class="cc-aide" data-type="' + (type || 'haut') + '">Besoin d’aide pour ta taille ? →</button>'
      + '<button type="button" class="cc-cta" disabled>Ajouter au panier</button>';
  }

  function wireSheet() {
    var selected = null;
    var cta = sheet.querySelector('.cc-cta');
    var help = sheet.querySelector('.cc-aide');
    if (help) help.addEventListener('click', function () {
      var t = help.getAttribute('data-type');
      if (window.SizeGuide21 && typeof window.SizeGuide21.open === 'function') { window.SizeGuide21.open(t); }
      else { window.location.href = TAILLE_URL; }
    });
    sheet.querySelectorAll('.cc-sz').forEach(function (b) {
      if (b.hasAttribute('disabled')) return;
      b.addEventListener('click', function () {
        sheet.querySelectorAll('.cc-sz').forEach(function (x) { x.classList.remove('cc-sel'); });
        b.classList.add('cc-sel');
        selected = b.getAttribute('data-vid');
        if (cta) cta.removeAttribute('disabled');
      });
    });
    if (cta) cta.addEventListener('click', function () {
      if (!selected) return;
      cta.setAttribute('disabled', 'disabled');
      cta.textContent = 'Ajout…';
      fetch('/cart/add.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ items: [{ id: parseInt(selected, 10), quantity: 1 }] })
      }).then(function (r) { if (!r.ok) throw new Error('add'); return r.json(); })
        .then(function () { showDone(); document.dispatchEvent(new CustomEvent('cart:refresh')); })
        .catch(function () { cta.removeAttribute('disabled'); cta.textContent = 'Réessayer'; });
    });
  }

  function showDone() {
    sheet.innerHTML = '<div class="cc-handle"></div><div class="cc-done">'
      + '<p>✓ Ajouté au panier</p>'
      + '<a class="cc-cta" href="/cart" style="display:block;text-align:center;text-decoration:none;">Voir mon panier</a>'
      + '<button type="button" class="cc-aide" style="border:none;background:none;cursor:pointer;margin:14px auto 0;">Continuer mes achats</button>'
      + '</div>';
    var cont = sheet.querySelector('.cc-aide');
    if (cont) cont.addEventListener('click', closeSheet);
  }

  function onAdd(card) {
    var handle = handleFromCard(card);
    if (!handle) return;
    var nameEl = card.querySelector('.product-card__name');
    var title = nameEl ? nameEl.textContent.trim() : '';
    var priceEl = card.querySelector('.product-card__price');
    var priceHTML = priceEl ? priceEl.innerHTML : '';
    openSheet('<div class="cc-handle"></div><div class="cc-lbl" style="margin-top:24px">Chargement…</div>');
    fetch('/products/' + handle + '.js')
      .then(function (r) { return r.json(); })
      .then(function (p) { openSheet(sheetHTML(p, title, priceHTML, detectType(p))); wireSheet(); })
      .catch(function () { openSheet('<div class="cc-handle"></div><div class="cc-lbl" style="margin-top:24px">Oups, réessaie.</div>'); });
  }

  function injectAdds() {
    if (!isMobile()) return;
    document.querySelectorAll('.product-card--style1.js-product-card').forEach(function (card) {
      if (card.dataset.ccInit) return;
      card.dataset.ccInit = '1';
      var wr = card.querySelector('.product-card__image-wr');
      if (!wr) return;
      var btn = document.createElement('button');
      btn.type = 'button'; btn.className = 'cc-add'; btn.setAttribute('aria-label', 'Ajout rapide'); btn.textContent = '+';
      btn.addEventListener('click', function (e) { e.preventDefault(); e.stopPropagation(); onAdd(card); });
      wr.appendChild(btn);
    });
  }

  function init() {
    injectAdds();
    new MutationObserver(injectAdds).observe(document.body, { childList: true, subtree: true });
    document.addEventListener('keydown', function (e) { if (e.key === 'Escape') closeSheet(); });
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init);
  else init();
})();